import React from 'react';
import App from './App';
import UpdateAvailablePage from '../routes/updateAvailable';
import { useServiceWorker } from '../hooks/useServiceWorker';

const UpdatableApp: React.FC = () => {
  const { assetsUpdateReady, updateAssets } = useServiceWorker();

  return assetsUpdateReady ? (
    <UpdateAvailablePage onUpdate={updateAssets} />
  ) : (
    <App />
  );
};

export default UpdatableApp;
